import { useMemo } from "react";

import { useSelectedResources } from "../../../../modules/Catalog/hooks/useSelectedResources";

const getName = <Resource extends { name?: string }>({ name }: Resource): string => name;

export const useSelectedResourcesNames = (): string[] => {
  const [selected] = useSelectedResources();

  return useMemo(() => (selected ? selected.map(getName) : []), [selected]);
};
